// Keep the visual and reading order identical while retaining native merchant card blocks.
const arrange = root => {
  for (const card of root.querySelectorAll('.zpc .product-card__content')) {
    const children = [...card.children];
    const title = children.find(el => el.matches('[ref="productTitleLink"]') || el.querySelector('[ref="productTitleLink"]'));
    const details = card.querySelector(':scope > .zpc__details');
    const review = card.querySelector(':scope > .zpc__demo-rating, :scope > .rating-wrapper');
    const swatches = card.querySelector(':scope > .zpc__demo-colours, :scope > product-swatches');
    const price = card.querySelector(':scope > product-price');
    const quick = card.querySelector(':scope > .zpc__quick');
    const gallery = card.querySelector(':scope > .card-gallery');
    if (review && gallery && gallery.nextElementSibling !== review) gallery.after(review);
    if (title && review && review.nextElementSibling !== title) review.after(title);
    let previous = title;
    for (const element of [details,swatches,price,quick]) {
      if (element && previous) { if (previous.nextElementSibling !== element) previous.after(element); previous = element; }
    }
  }
};
arrange(document);
document.addEventListener('shopify:section:load', event => arrange(event.target));

// Pagination, filters and section hydration can insert cards after initial load.
let pending = false;
const observer = new MutationObserver(records => {
  if (pending || !records.some(record => [...record.addedNodes].some(node => node instanceof Element && (node.matches('.zpc, .product-card__content') || node.closest('.zpc') || node.querySelector('.zpc'))))) return;
  pending = true;
  requestAnimationFrame(() => { pending = false; arrange(document); });
});
observer.observe(document.documentElement, {childList:true, subtree:true});